import { Context } from "../Engine";
import { ITexture } from "./ITexture";

export class ImageTexture implements ITexture {
    public translucent: boolean;
    public glTexture: WebGLTexture;
    public config: TextureSettings;
    private image: HTMLImageElement;

    constructor(config: TextureSettings) {
        this.config = config;
        this.glTexture = null;
        this.translucent = false;
    }

    public async load(ctx: Context): Promise<ImageTexture> {

        return new Promise((resolve, reject) => {

            let gl = ctx.gl;
            let texture = gl.createTexture();
            this.glTexture = texture;
            this.image = new Image();
            this.image.onload = () => {
                gl.bindTexture(gl.TEXTURE_2D, texture);
                gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
                gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.image);

                // Make texture options dependant on settings levels

                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
                gl.generateMipmap(gl.TEXTURE_2D);

                gl.bindTexture(gl.TEXTURE_2D, null);

                resolve(this);
            };

            this.image.onerror = () => {
                reject(new Error(`Could not load texture image from ${this.config.source}`));
            };

            this.image.src = this.config.source;
        });
    }
}

type TextureSettings = {
    source: string;
}